<template>
	<core-layout-content large>
		<div class="xs-12 flex xs-center wrap p4 md-pt2 md-p8 pb10 mt4">
			<!-- Left  -->
			<div class="xs-12 md-7 md-pr4">
				<!-- Loading toast -->
				<j-spinner v-if="isLoading" />

				<div class="p2">
					<transaction-info
						:data="transactionDetails"
						@onUpdate="fetchTransactions"
					/>

					<transaction-facts
						:id="transactionDetails.id"
						:facts="computedFacts"
						@added="fetchTransactions"
						@updated="fetchTransactions"
						@deleted="fetchTransactions"
					/>
				</div>
			</div>

			<!-- Right -->
			<div class="xs-12 md-5 md-pl4">
				<core-info-card :data="computedInfo" class="mt6" :hasReferral="false" />
			</div>
			<!-- Footer menu -->
			<div class="flex wrap xs-12 xs-right bt1 bc7 pt2 mt8">
				<j-button
					type="error"
					@click="$modal.show('j-dialog')"
					v-can="'writeTransactions'"
					action="showDeleteTransactionModal"
				>
					<crm-icon name="delete" size="normal" color="c5" class="mr1" />
					{{ $t("delete") }}
				</j-button>
			</div>

			<!-- Delete Confirmation Modal -->
			<j-dialog
				:title="$t('delete')"
				type="delete"
				@confirm="onDelete(transactionDetails.id)"
				>{{ $t("errors.are_you_sure_you_want_to_delete_transaction") }}
			</j-dialog>
		</div>
	</core-layout-content>
</template>

<script>
import CoreInfoCard from "@/modules/core/components/CoreInfoCard"
import JCard from "@/components/JCard"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import JButton from "@/components/JButton/"
import JDialog from "@/components/JDialog/"
import JSpinner from "@/components/JSpinner/"
import CrmIcon from "@/components/CrmIcon"

import TransactionFacts from "./../components/TransactionFacts"
import TransactionInfo from "./../components/TransactionInfo"

import api from "./../api"
import get from "lodash.get"

export default {
	components: {
		CoreInfoCard,
		JCard,
		JDialog,
		JButton,
		JSpinner,
		CrmIcon,
		TransactionFacts,
		CoreLayoutContent,
		TransactionInfo
	},
	data: () => ({
		transactionDetails: {},
		isLoading: false
	}),
	created() {
		this.fetchTransactions()
	},
	computed: {
		computedInfo() {
			return {
				status: this.transactionDetails.status,
				createdAt: this.transactionDetails.createdAt,
				createdBy: this.transactionDetails.createdBy,
				lastModifiedAt: this.transactionDetails.lastModifiedAt,
				lastModifiedBy: this.transactionDetails.lastModifiedBy
			}
		},

		computedFacts() {
			const { facts } = this.transactionDetails
			if (!facts) return []

			return facts.map(item => ({
				id: item.id,
				label: item.type,
				value: item.value
			}))
		}
	},
	methods: {
		async onDelete(id) {
			this.isLoading = true
			const res = await api.deleteTransaction({ transactionId: id })
			this.isLoading = false

			if (res?.data?.deleteTransaction?.status === "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "success",
						text: this.$t("transaction_removed")
					}
				})
				this.$router.push(`/${this.$store.state.tenantId}/transactions/`)
			} else {
				this.$store.dispatch("showError", [this.$t("something_went_wrong")])
			}
		},

		async fetchTransactions() {
			this.isLoading = true
			const idUrl = this.$route.params.id
			const res = await api.queryTransactionDetail({
				where: { id: idUrl }
			})
			this.isLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}
			// Success
			this.transactionDetails = get(res, "data.transactions.list", [])[0]
			console.log("transactionDetails", this.transactionDetails)
		}
	}
}
</script>
